export default {
  buttons: {
    next: "İleri",
    prev: "Geri",
    skip: "Atla",
    done: "Bitti",
    gotIt: "Anladım",
  },
  messages: {
    dontShowAgainLabel: "Bir daha gösterme",
    stepNumbersOfLabel: "/",
  },
};
